var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-anchor",style:(_vm.styles),attrs:{"id":_vm.$attrs._id}},[_c('div',{staticClass:"tag-line",style:(_vm.lineStyle)}),(_vm.tailPosition !== 'none')?_c('div',{staticClass:"tag-dot"}):_vm._e(),_c('div',{ref:"el",staticClass:"tag-action",class:[
      `tag-action--${_vm.type}`
    ],style:(_vm.labelStyle),on:{"click":_vm.triggerAction}},[_c('fa',{attrs:{"icon":_vm.icon,"fixed-width":""}}),_c('div',{staticClass:"tag-action__ring"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }